import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import { NavigateFunction } from "react-router-dom";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { handleBulkResolve } from "./HealthMonitoringUtils/handleBulkResolve";

export const BulkSceneChangeOutcomesDialog = ({
  bulkSceneChangeOutcomesDialogOpen,
  setBulkSceneChangeOutcomesDialogOpen,
  setUpdatingStatus,
  setAlertsData,
  alertsData,
  setFectchingAllData,
  setUnhealthyCamsData,
  unhealthyCamsData,
  clickedTab,
  setActiveTable,
  setAlertStatusDialogOpen,
  setSelectedRow,
  setSelectedRowIndex,
  setSortedData,
  singleCellActivated,
  activeName,
  filters,
  alertFilter,
  setBackgroundFrame,
  setDetectedFrame,
  setSelectedRows,
  selectedRows,
  setErrorsOverviewData,
  setCameraStatsData,
  setLoadingCameraStatsData,
  setBandwidthData,
  setLoadingBandwidthData,
  setShowSiteStats,
  cameraDropDownValue,
  setFilteredDataLengths,
  setSceneChangeOutcomesDialogOpen,
  sceneChangeValueString,
  setSceneChangeValueString,
  navigate,
}: {
  bulkSceneChangeOutcomesDialogOpen: boolean;
  setBulkSceneChangeOutcomesDialogOpen: Dispatcher<boolean>;
  alertsArray: any;
  setUpdatingStatus: Dispatcher<boolean>;
  setAlertsData: any;
  alertsData: any;
  setFectchingAllData: any;
  setUnhealthyCamsData: any;
  unhealthyCamsData: any;
  clickedTab: any;
  setActiveTable: any;
  setAlertStatusDialogOpen: any;
  setSelectedRow: any;
  setSelectedRowIndex: any;
  setSortedData: any;
  singleCellActivated: any;
  activeName: any;
  filters: any;
  alertFilter: any;
  setBackgroundFrame: Dispatcher<string>;
  setDetectedFrame: Dispatcher<string>;
  setSelectedRows: any;
  selectedRows: any;
  setErrorsOverviewData: any;
  setCameraStatsData: any;
  setLoadingCameraStatsData: any;
  setBandwidthData: any;
  setLoadingBandwidthData: any;
  setShowSiteStats: any;
  cameraDropDownValue: any;
  setFilteredDataLengths: any;
  setSceneChangeOutcomesDialogOpen: Dispatcher<boolean>;
  sceneChangeValueString: string;
  setSceneChangeValueString: Dispatcher<string>;
  navigate: NavigateFunction;
}) => {
  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSceneChangeValueString((event.target as HTMLInputElement).value);
  };

  const alertsArray = JSON.parse(
    localStorage.getItem("selectedCHMAlertsArray") || "[]"
  );

  return (
    <Dialog open={bulkSceneChangeOutcomesDialogOpen}>
      {" "}
      <DialogContent sx={{ width: 575, padding: 4 }}>
        <DialogContentText
          sx={{
            fontSize: 18,
            color: "black",
            fontFamily: "mulish",
            fontWeight: "bold",
          }}
        >
          Some of these alerts are for sudden scene changes.
        </DialogContentText>
        <DialogContentText
          sx={{
            fontSize: 18,
            color: "black",
            fontFamily: "mulish",
            fontWeight: "bold",
          }}
        >
          Choose the preferred action for your current reference image bank:
        </DialogContentText>
        <br></br>
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          defaultValue="female"
          name="radio-buttons-group"
          onChange={handleRadioChange}
        >
          <FormControlLabel
            sx={{ fontFamily: "mulish" }}
            value="reset"
            control={<Radio />}
            label="Reset all reference images to current view."
          />
          <FormControlLabel
            sx={{ fontFamily: "mulish" }}
            value="add"
            control={<Radio />}
            label="Add the detected image to your current reference image library."
          />
        </RadioGroup>
      </DialogContent>
      <DialogActions sx={{ padding: 3 }}>
        <button
          className="shadow-button bg-actuate-orange border-1	border-actuate-orange rounded font-mulish text-white text-base p-1.5 w-[100px]"
          onClick={() => {
            setBulkSceneChangeOutcomesDialogOpen(false);
            setUpdatingStatus(true);
            handleBulkResolve(
              alertsArray,
              setAlertsData,
              "resolved",
              alertsData,
              setFectchingAllData,
              setUnhealthyCamsData,
              unhealthyCamsData,
              clickedTab,
              setActiveTable,
              setAlertStatusDialogOpen,
              setSelectedRow,
              setSelectedRowIndex,
              setSortedData,
              singleCellActivated,
              activeName,
              setUpdatingStatus,
              filters,
              alertFilter,
              setSceneChangeOutcomesDialogOpen,
              setBackgroundFrame,
              setDetectedFrame,
              setSelectedRows,
              selectedRows,
              setErrorsOverviewData,
              setCameraStatsData,
              setLoadingCameraStatsData,
              setBandwidthData,
              setLoadingBandwidthData,
              setShowSiteStats,
              cameraDropDownValue,
              setFilteredDataLengths,
              sceneChangeValueString,
              setBulkSceneChangeOutcomesDialogOpen,
              navigate
            );
          }}
        >
          Submit
        </button>
      </DialogActions>
    </Dialog>
  );
};
